import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Inbox from "@/pages/Inbox";
import Leads from "@/pages/Leads";
import KnowledgeBase from "@/pages/KnowledgeBase";
import Vehicles from "@/pages/Vehicles";
import Agents from "@/pages/Agents";
import PublicChat from "@/pages/PublicChat";
import Settings from "@/pages/Settings";
import Campaigns from "@/pages/Campaigns";
import Integrations from "@/pages/Integrations";
import Supervisor from "@/pages/Supervisor";
import Training from "@/pages/Training";
import InviteAccept from "@/pages/InviteAccept";
import { AuthProvider } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { LanguageProvider } from "@/contexts/LanguageContext";

export default function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/invite/:token" element={<InviteAccept />} />
              <Route path="/chat" element={<PublicChat />} />
              <Route element={<Layout />}>
                <Route index element={<Dashboard />} />
                <Route path="/inbox" element={<Inbox />} />
                <Route path="/leads" element={<Leads />} />
                <Route path="/integrations" element={<Integrations />} />
                <Route path="/webhooks" element={<Navigate to="/integrations" replace />} />
                <Route path="/knowledge" element={<KnowledgeBase />} />
                <Route path="/vehicles" element={<Vehicles />} />
                <Route path="/agents" element={<Agents />} />
                <Route path="/campaigns" element={<Campaigns />} />
                <Route path="/supervisor" element={<Supervisor />} />
                <Route path="/training" element={<Training />} />
                <Route path="/settings" element={<Settings />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </LanguageProvider>
    </ThemeProvider>
  );
}
